
import React from 'react';
import {
    DoneChip, EmailSubsectionChip,
    IconAuditTrail, IconCalendarPaid, IconFileEmpty,
    IconTraffic,
    PersonChip, PhoneSubsectionChip
} from '../../../../../components/buttons/IconButtons';
import { EMPTY_VALUES } from '../../../../../Apis/functions';
import CustomCard from '../../../../../components/CustomCard';
import BannerComponentUser from './Components/BannerComponentUser';
import { userType } from '../../../../../enums/userTypeEnum';
import FineStatusStepper from '../SubComponents/StatusFines';
import AmountComponent from './Components/AmountComponent';
import CustomModal from '../../../../../components/Modal/CustomModal';
import ComponentHeaderBack from './Components/ComponentHeaderBack';
import {STATUS_MODEL} from '../../../../../enums/statusEnum';
import PaymentConfirmationModalApp from '../Functionality/PaymentConfirmationModalApp';
import CustomFileCard from '../../../../../components/CustomFileCard';
import CustomTooltip from '../../../../../components/CustomTooltip';
import {TYPE_PAYMENT} from '../Model/Model';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 * s
 */
const PaymentConfirmationModal = (
    { show, onHide }
) => {

    const {t, dataFile, trafficData, handleDownloadFiles} = PaymentConfirmationModalApp({onHide});


    return (
        <CustomModal
            show={show}
            buttonConfirm="download"
            size='lg'
            onHide={() => {
                onHide();
            }}
            onConfirm={() => {
                handleDownloadFiles();
            }}
            closeButton={false}
            confirmButton={true}
            cancelButton={true}
            classNameBody={'p-0 m-0'}
        >
            <>
                <ComponentHeaderBack
                    onHide={() => {
                        onHide();
                    }}
                    title={`${STATUS_MODEL.PAID === parseInt(trafficData?.statusId) ?   '#' + trafficData?.folio : 'confirmation'}`}
                    classNameTitle={`fs-24px ibl-font-w-600 ml-2 ${STATUS_MODEL.PAID === parseInt(trafficData?.statusId) ? 'font-color-text-950' : 'font-color-success-700'}`}
                    trafficData={trafficData}
                    icon={STATUS_MODEL.PAID === parseInt(trafficData?.statusId) ? <div> <IconTraffic className='w-32px' /></div> : <div><DoneChip className='icon-color-success-700 w-32px' /></div> }
                    showCustomChip={true}
                    showVerticalSeparator={true}
                />
                <div className="mb-3">
                <CustomCard classes={"w-100"} classCard={'card-border-8px'} classContent={'p-0 m-0'}>
                    <div className="d-flex justify-content-between align-items-center m-3">
                        <BannerComponentUser
                            title={trafficData?.fullName || EMPTY_VALUES.DEFAULT}
                            nameChip={userType[trafficData?.userTypeId] ? t(userType[trafficData?.userTypeId]) : EMPTY_VALUES.DEFAULT}
                            icon={<PersonChip width={32} height={32} />}
                        />
                        <FineStatusStepper
                            statusId={trafficData?.statusId}
                            statusScheduleId={trafficData?.statusScheduleId}
                            finePaymentDate={trafficData?.finePaymentDate}
                            createdAtFine={trafficData?.createdAt}
                            discountDate={trafficData?.discountDate}
                            paymentDate={trafficData?.paymentDate}
                            suspendedAccountDate={trafficData?.suspendedAccountDate}
                            discountApplied={trafficData?.discountApplied}
                            t={t}
                        />
                    </div>
                    <div className="border-bottom-shades-300" />
                    <CustomCard classes={"w-100"} classCard={'border-0'}>
                        <div className="row">
                            <div className="col-6 px-0">
                                <CustomCard classes={"w-100"} classCard={'card-border-8px'} classContent={'p-0 m-0'}>
                                    <div className="d-flex justify-content-start align-items-center p-3">
                                        <div><IconAuditTrail className="icon-color-general-950" /></div>
                                        <p className="px-3 fs-14px ibl-font-w-600 font-color-general-950">{t("audit_trail")}</p>
                                    </div>
                                    <div className="border-bottom-shades-300" />
                                    <CustomCard classes={"w-100"} classCard={'border-0'}>
                                        <div className="d-flex align-items-center gap-2">
                                            <div className="d-flex">
                                                <div className={`w-56px-h-56px background-primary-100 d-flex align-items-center justify-content-center mr-3`}>
                                                    <IconCalendarPaid className="icon-color-general-950" />
                                                </div>
                                                <div className="d-flex flex-column">
                                                    <p className="fs-12px ibl-font-w-600 font-color-general-950">{trafficData?.paymentType === TYPE_PAYMENT.CONDONATION ? t("condoned_by") : t("paid_by") }</p>
                                                    <p className="fs-14px ibl-font-w-400 font-color-shades-700">{trafficData?.fullNameMarkedBy || EMPTY_VALUES.DEFAULT}</p>
                                                    <div className={"row d-flex"}>
                                                        <div className={"col-6 px-0"}>
                                                            <div className={"d-flex align-items-center"}>
                                                                <div className={'mr-8px'}><EmailSubsectionChip/></div>
                                                                <div className={"flex-grow-1 minw-0"}>
                                                                    <CustomTooltip
                                                                        text={trafficData?.emailMarkedBy || EMPTY_VALUES.DEFAULT}
                                                                        classes={`fs-12px text-ellipsis-1-row`}
                                                                        showIfTruncated={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={"col-6 pl-2 pr-0"}>
                                                            <div className={"d-flex align-items-center"}>
                                                                <div className={'mr-8px'}><PhoneSubsectionChip/></div>
                                                                <div className={"flex-grow-1 minw-0"}>
                                                                    <CustomTooltip
                                                                        text={trafficData?.phoneNumberMarkedBy || EMPTY_VALUES.DEFAULT}
                                                                        classes={`fs-12px text-ellipsis-1-row`}
                                                                        showIfTruncated={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </CustomCard>
                                </CustomCard>

                            </div>
                            <div className="col-6 pl-3 pr-0 d-flex flex-column gap-2">
                                <p className="fs-14px ibl-font-w-600 font-color-general-950">{t("description")}</p>
                                <p className="fs-14px ibl-font-w-400 font-color-general-950">{trafficData?.paymentDescription || EMPTY_VALUES.DEFAULT}</p>
                                <div className="border-bottom-shades-300" />
                                <p className="fs-14px ibl-font-w-600 font-color-general-950">{t("attached_documents")}</p>
                                <div className="pb-2">
                                    <CustomFileCard
                                        Icon={dataFile?.icon || IconFileEmpty }
                                        title={dataFile?.title || t('not_yet') }
                                        subtitle={
                                            <p className={"justify-content-start d-flex ibl-font-w-400 fs-10px"}>
                                                {dataFile?.size || EMPTY_VALUES.DEFAULT }
                                            </p>
                                        }
                                        classes="card-shades-300-50 border-radius-8px"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-end">
                            <AmountComponent
                                className="col-6 pl-3 pr-0"
                                folio={trafficData?.folio}
                                subtotal={trafficData?.fineAmount}
                                discount={trafficData?.discountAmount}
                                penalty={trafficData?.penaltyAmount}
                                paymentType={trafficData?.paymentType}
                                total={trafficData?.paidAmount}
                                isPaid={trafficData?.statusId === STATUS_MODEL.PAID }
                            />
                        </div>
                    </CustomCard>
                </CustomCard>
                </div>
            </>
        </CustomModal>
    );

}

export default PaymentConfirmationModal
